import React from 'react';

export const panelCls =
  'p-space-lg lg:p-space-xl rounded-xl bg-surface-container-lowest border border-surface-container shadow-sm';
export const inputCls =
  'w-full h-11 px-space-md bg-surface-container-low rounded-lg border border-surface-container font-body-md text-body-md text-outline focus:outline-none focus:border-surface-tint focus:ring-1 focus:ring-surface-tint transition-all placeholder:text-on-surface-variant/60';
export const labelCls =
  'font-label-sm text-label-sm uppercase tracking-wider text-on-surface-variant mb-space-xs font-semibold block';
export const primaryBtn =
  'h-11 px-space-lg rounded-lg bg-surface-tint text-on-primary font-label-md text-label-md uppercase tracking-wider font-semibold hover:bg-primary transition-all disabled:opacity-60 inline-flex items-center justify-center gap-space-xs';
export const ghostBtn =
  'h-11 px-space-lg rounded-lg bg-surface-container text-outline font-label-md text-label-md uppercase tracking-wider font-semibold hover:bg-surface-container-high transition-colors inline-flex items-center justify-center gap-space-xs';

export const Field = ({ label, hint, children, htmlFor }) => (
  <div>
    <label className={labelCls} htmlFor={htmlFor}>{label}</label>
    {children}
    {hint ? <p className="font-body-sm text-[12px] text-on-surface-variant mt-1">{hint}</p> : null}
  </div>
);

export const SectionHead = ({ eyebrow, title, children }) => (
  <div className="flex flex-col md:flex-row md:items-end justify-between gap-space-sm mb-space-lg">
    <div>
      <span className="font-label-md text-label-md uppercase tracking-widest text-primary font-bold">{eyebrow}</span>
      <h3 className="font-headline-md text-headline-sm lg:text-headline-md tracking-tight text-outline">{title}</h3>
    </div>
    {children}
  </div>
);

export const Note = ({ children, testId }) => (
  <p
    data-testid={testId}
    className="font-body-sm text-body-sm text-on-surface-variant leading-relaxed p-space-md rounded-lg bg-primary-container/60 border-l-2 border-surface-tint"
  >
    {children}
  </p>
);

export const Stat = ({ label, value, sub, accent }) => (
  <div className="p-space-md rounded-lg bg-surface border border-surface-container">
    <span className="font-label-sm text-label-sm uppercase tracking-wider text-on-surface-variant block">{label}</span>
    <p className={`font-headline-sm text-title-md font-bold mt-1 ${accent ? 'text-surface-tint' : 'text-outline'}`}>{value}</p>
    {sub ? <p className="font-body-sm text-[12px] text-on-surface-variant mt-0.5 leading-snug">{sub}</p> : null}
  </div>
);
